export default {
  INTERNAL: 'internal',
  DOCTOR: 'doctor'
};
